const roles = Object.freeze({
  EDITOR: 'editor',
  OWNER: 'owner',
  READER: 'reader'
})
export default roles
